<template>
  <div class="card">
    <div class="card-header">
      Security Details
    </div>
    <div class="p-6">
      <form @submit.prevent="updateAccount()">
        <fieldset class="form-group">
          <label for="access_code" class="form-label">Access Code</label>
          <input id="access_code" type="text" class="form-input" v-model="form.access_code">
          <div class="mt-1 text-xs text-gray-500">This is the code used to access views with sensitive data, like the Monitor Dashboard.</div>
        </fieldset>
        <button type="submit" class="btn btn-primary" v-submitting="submitting">
          Save Details
        </button>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'SettingsSecurity',

    metaInfo: {
      title: 'Security Settings'
    },

    created () {
      this.form = JSON.parse(JSON.stringify(this.account))
    },

    computed: {
      ...mapState(['user']),
      ...mapGetters(['account'])
    },

    data () {
      return {
        submitting: false,
        form: {
          access_code: ''
        }
      }
    },

    methods: {
      async updateAccount () {
        try {
          this.submitting = true
          await this.$api.patch(`account/${this.$route.params.account}/accounts/${this.form.id}`, this.form)
          this.$store.dispatch('syncUser', this)
          this.$toasted.show('Security Settings Updated')
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>